import { getReplay } from '@sentry/angular';

/**
 * Records a Session Replay for every customer who reaches checkout.
 *
 * Production samples 10% of sessions, but because replaysOnErrorSampleRate is 1 the other 90% are
 * already recording into Replay's 60 second ring buffer without uploading anything. flush() commits
 * that buffer and switches the session to continuous recording, and starts a recording outright if
 * none is running, so this single call covers both cases.
 *
 * start() would not work here: it returns early while a buffer is in progress, which is the state
 * most production sessions are in. The SDK logs "Buffering is in progress, call `flush()` to save
 * the replay" when that happens.
 *
 * The replay therefore begins about 60 seconds before checkout rather than at the start of the
 * visit — the ring buffer is all the history that exists.
 */
export const checkoutReplayResolver = (): void => {
    // Replay is browser-only, and resolvers also run during SSR.
    if (typeof window === 'undefined') {
        return;
    }
    getReplay()
        ?.flush()
        .catch(() => {
            // A dropped flush only costs us this replay; never fail checkout navigation for it.
        });
};
